import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/LocalOffer';
import create from './create';
import edit from './edit';
import list from './list';

const offers: ResourceProps = {
  name: 'offers',
  icon,
  options: { label: 'Promoções' },
  create,
  edit,
  list
};

export default offers;
